var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('z-switch',{attrs:{"value":_vm.value,"loading":_vm.loading,"size":"large"},on:{"on-change":_vm.on_change}})}
var staticRenderFns = []

export { render, staticRenderFns }